module.exports = __webpack_public_path__ + "img/banner.3a3f9c61.jpg";